import api from './authService';

// ===========================================
// Types
// ===========================================

export interface DashboardSummary {
  this_month_revenue: number;
  last_month_revenue: number;
  total_revenue: number;
  growth_rate: number;
  pending_payouts: number;
  pending_payout_count: number;
  active_tenants: number;
  total_users: number;
  this_month_transactions: number;
}

export interface RevenueTrendItem {
  year: number;
  month: number;
  label: string;
  revenue: number;
  count: number;
}

export interface TenantRevenue {
  id: number;
  name: string;
  total_revenue: number;
  transaction_count: number;
  this_month_revenue: number;
}

export interface ProductRevenue {
  id: number;
  name: string;
  code: string;
  total_revenue: number;
  transaction_count: number;
}

export interface RecentTransaction {
  id: number;
  transaction_date: string;
  tenant_name: string | null;
  product_name: string | null;
  customer_name: string | null;
  customer_email: string | null;
  gross_amount: number;
  status: string;
  payment_source: string;
}

export interface PendingPayout {
  id: number;
  recipient_name: string;
  recipient_email: string | null;
  tenant_name: string | null;
  net_amount: number;
  period_start: string | null;
  period_end: string | null;
  created_at: string | null;
}

// ===========================================
// API
// ===========================================

export const getDashboardSummary = async (): Promise<DashboardSummary> => {
  const response = await api.get<DashboardSummary>('/admin/dashboard/summary');
  return response.data;
};

export const getRevenueTrend = async (months: number = 6): Promise<RevenueTrendItem[]> => {
  const response = await api.get<{ data: RevenueTrendItem[] }>(`/admin/dashboard/revenue-trend?months=${months}`);
  return response.data.data;
};

export const getRevenueByTenant = async (limit: number = 10): Promise<TenantRevenue[]> => {
  const response = await api.get<{ data: TenantRevenue[] }>(`/admin/dashboard/revenue-by-tenant?limit=${limit}`);
  return response.data.data;
};

export const getRevenueByProduct = async (limit: number = 10): Promise<ProductRevenue[]> => {
  const response = await api.get<{ data: ProductRevenue[] }>(`/admin/dashboard/revenue-by-product?limit=${limit}`);
  return response.data.data;
};

export const getRecentTransactions = async (limit: number = 10): Promise<RecentTransaction[]> => {
  const response = await api.get<{ data: RecentTransaction[] }>(`/admin/dashboard/recent-transactions?limit=${limit}`);
  return response.data.data;
};

export const getPendingPayouts = async (): Promise<{
  data: PendingPayout[];
  total_amount: number;
  count: number;
}> => {
  const response = await api.get('/admin/dashboard/pending-payouts');
  return response.data;
};
